import {Entity} from '@s-ui/domain'

export class MessagingConversationIdEntity extends Entity {
  #conversationId

  /**
   * @param {String} conversationId
   * */
  static create({conversationId}) {
    return new MessagingConversationIdEntity({conversationId})
  }

  constructor({conversationId}) {
    super()
    this.#conversationId = conversationId
  }

  get conversationId() {
    return this.#conversationId
  }

  toJSON() {
    return {
      conversationId: this.conversationId
    }
  }
}
